import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import ToastHandler from '../components/toasthandler';

import {
  fetchReferrals,
} from '../actions';

class Referral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refPath: 'https://trade.vaultoro.com/register?ref=',
      useEmail: '',
      showMore: false,
    };
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchReferrals());
  }

  copyToClipboard(e) {
    this.referralCode.select();
    document.execCommand('copy');
    e.target.focus();
    return toast.success(
      <div>
        <div className="toast-icon">
          <img alt="success" src={ process.env.REACT_APP_CDN + '/assets/icons/tick.svg'} />
        </div>
        <div className="toast-info">
          Copied referral link
        </div>
      </div>
    );
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  render() {
    const { referrals } = this.props;
    const { refPath, useEmail, showMore } = this.state

    let referralUrl;
    let directRate;
    let indirectRate;

    if (refPath && referrals && referrals.code) {
      referralUrl = refPath + referrals.code
    }

    if (referrals && referrals.fees && referrals.fees.length) {
      directRate = referrals.fees.filter(function(item) {
        return item.type === 'REFERRAL_DIRECT';
      });
      indirectRate = referrals.fees.filter(function(item) {
        return item.type === 'REFERRAL_INDIRECT';
      });
    }

    const emailShare = `mailto:${useEmail}?subject=Join Vaultoro&body=I use ${referralUrl} to convert crypto profits to physical gold %26 silver bullion secured in a top-tier Swiss vaulting facility, fully insured, audited %26 bank independent. Trade back to bitcoin any time. Vaultoro is VC backed %26 has been around since 2015.`;

    const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=I use ${referralUrl} to convert crypto profits to physical gold & silver bullion secured in a top-tier Swiss vaulting facility, fully insured, audited & bank independent. Trade back to bitcoin any time. Vaultoro is VC backed & has been around since 2015.`;

    const twitterShare = `https://twitter.com/intent/tweet?text=I use ${referralUrl} to convert %23crypto profits to physical gold %26 silver bullion secured in a top-tier Swiss vaulting facility, fully insured, audited %26 bank independent. Trade back to %23bitcoin any time. Vaultoro is VC backed %26 has been around since 2015.`;

    const whatsappShare = `whatsapp://send?text=I%20use%20${referralUrl}%20to%20convert%20%23crypto%20profits%20to%20physical%20gold%20%26%20silver%20bullion%20secured%20in%20a%20top-tier%20Swiss%20vaulting%20facility,%20fully%20insured,%20audited%20%26%20bank%20independent.%20Trade%20back%20to%20%23bitcoin%20any%20time.%20Vaultoro%20is%20VC%20backed%20%26%20%has%20been%20around%20since%202015.`;

    const telegramShare = `https://t.me/share/url?url=${referralUrl}text=I%20use%20Vaultoro%20to%20convert%20%23crypto%20profits%20to%20physical%20gold%20%26%20silver%20bullion%20secured%20in%20a%20top-tier%20Swiss%20vaulting%20facility%2C%20fully%20insured%2C%20audited%20%26%20bank%20independent.%20Trade%20back%20to%20%23bitcoin%20any%20time.%20Vaultoro%20is%20VC%20backed%20%26%%20%has20been%20around%20since%202015.`;

    return (
      <div className="grid-x">
        <ToastHandler />
        <div className="ref-panel cell panel small-12 medium-12 large-12">
          <div className="ref-more">
            <div>
              <h3>Referrals</h3>
              <p className="hide-mob">Tell your friends about Vaultoro, earn Bitcoin!</p>
              <p className="show-mob">How does it work?</p>
            </div>
            <div>
              <div className="ref-chev" onClick={() => this.setState({showMore: !showMore})}>
                {showMore ? (
                  <FontAwesomeIcon
                    icon={faChevronUp}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faChevronDown}
                  />

                )}
              </div>
            </div>
          </div>
          <div>

            <div className={showMore ? (
              'ref-how'
            ) : (
              'ref-how rh-hide'
            )}>

              <div className="rh-i">
                <div className="cir-img">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/send-invitation.svg'} />
                </div>
                <div>
                  <p><b>
                    Send Invitation
                  </b></p>
                </div>
                <div>
                  Send your referral link to friends and tell them how cool Vaultoro is.
                </div>
              </div>
              <div className="rh-l"></div>
              <div className="rh-i">
                <div className="cir-img">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/registration.svg'} />
                </div>
                <div>
                  <p><b>
                    Registration
                  </b></p>
                </div>
                <div>
                  When someone clicks on your referral link the cookie lasts for 60 days even if they don&apos;t sign up straight away!
                </div>
              </div>
              <div className="rh-l"></div>
              <div className="rh-i">
                <div className="cir-img">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/earn-bitcoin.svg'} />
                </div>
                <div>
                  <p><b>
                    Earn Bitcoin
                  </b></p>
                </div>
                <div>
                  <span className="ref-li">&bull;</span> 20% of all trading fees paid by your referral for next 2 years!
                  <br />
                  <span className="ref-li">&bull;</span> 5% of all trading fees paid by a referral of your referral (Tier2)*.
                </div>
              </div>

            </div>

          </div>
        </div>

        <div className="ref-panel cell panel small-12 medium-12 large-12">
          <div>
            <div>
              <h3>Invite your friends</h3>
              <p>Insert your friends&apos; email addresses and send them an invitation to join Vaultoro!</p>
            </div>
            <div className="ref-inp" style={{marginBottom: '40px'}}>
              <div>
                <input id="useEmail" className="input" type="text" name="Email Address" placeholder="Email Address" value={useEmail} onChange={this.handleChange} />
              </div>
              <div>
                <a href={emailShare} target="_blank" rel="noopener noreferrer" className="cir-b">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/send.svg'} />
                </a>
              </div>
            </div>
          </div>

          <div>
            <div>
              <h3>Share the referral link</h3>
              <p>You can also share your referral link by copying and sending it or sharing it on your social media.</p>
            </div>
            <div className="ref-inp ri-2r-m">
              <div>
                <input className="input" type="text" name="referral" placeholder="Referral Code" value={referralUrl || refPath} readOnly ref={(referralcode) => this.referralCode = referralcode} />
                <button type="button" className="ref-inp-cop" onClick={this.copyToClipboard}>
                  Copy Link
                </button>
              </div>
              <div>
                <a href={facebookShare} target="_blank" rel="noopener noreferrer" className="cir-b">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/facebook.svg'} />
                </a>
                <a href={twitterShare} target="_blank" rel="noopener noreferrer" className="cir-b">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/twitter.svg'} />
                </a>
                <a href={whatsappShare} target="_blank" rel="noopener noreferrer" className="cir-b">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/whatsapp.svg'} />
                </a>
                <a href={telegramShare} target="_blank" rel="noopener noreferrer" className="cir-b">
                  <img alt='Send' src={ process.env.REACT_APP_CDN + '/assets/icons/v2/telegram.svg'} />
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  referrals: state.referral.referral,
});

export default connect(mapStateToProps)(Referral);
